import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'subscription.loading.details': {
    id: 'subscription.loading.details',
    defaultMessage: 'Loading subscription...',
    description: 'Message when subscription page is being loaded',
  },
});

export default messages;
